import useListboxFetch from "root/ReactHookForm/ui/useListboxFetch";
import {CommonDropdown} from "root/ReactHookForm/ui/CommonDropdown";
import SpinnerDiv from "ui/ReactSpinnerDiv";

const NCC_LEA = 1; //Ask neil about placement for this

const DropdownSchools2 = ({onChange}) =>
{
    const fields = { url: '/lea/' + NCC_LEA + '/schools', keyFieldName: 'school_id', labelFieldName: 'school_name', additionalFields: ['enc_school_id'] }

    const [ isLoading, items ] = useListboxFetch( fields ) ;

    return (
        <div>
            {isLoading === false && <CommonDropdown items={items} onChange={onChange}/>}
            {isLoading === true && <SpinnerDiv/>}
        </div>
    )
}

export default DropdownSchools2;